"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.flyOutActions = exports.FlyOutReducerUI = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.html-utils");

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.icon-library"));

var _FlyOutReducer = _interopRequireWildcard(require("./FlyOutReducer"));

require("./FlyOut.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FlyOutReducerUI = _FlyOutReducer["default"];
exports.FlyOutReducerUI = FlyOutReducerUI;
var flyOutActions = _FlyOutReducer.actions;
/* This indicates in which div, modal is going to be placed <div id="modal-root"></div> */

exports.flyOutActions = flyOutActions;
var flyOutRoot = document.getElementById('flyout-root');
/* Opacity div (flyout) */

var ANIMATION_FLYOUT_IN_1 = 'opacityLayout';
var ANIMATION_FLYOUT_OUT_1 = 'opacityOff';
/* container div (flyout) */

var ANIMATION_FLYOUT_IN_2 = 'flyIn';
var ANIMATION_FLYOUT_OUT_2 = 'flyMeToTheMoon';

var isIE = function isIE() {
  var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object

  var msie = ua.indexOf('MSIE '); // IE 10 or older

  var trident = ua.indexOf('Trident/'); //IE 11

  return msie > 0 || trident > 0;
};
/**
 * Statefull component to flyOut
 * @param {string} idFlyOut Identifies this flyOut on setupBasics
 * @param {JSX} children Children rendered.
 * @returns {JSX} Component JSX.
 */


var FlyOut = /*#__PURE__*/function (_Component) {
  _inherits(FlyOut, _Component);

  var _super = _createSuper(FlyOut);

  function FlyOut() {
    var _this;

    _classCallCheck(this, FlyOut);

    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(props));

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var _this$state = _this.state,
          animationListener = _this$state.animationListener,
          mounted = _this$state.mounted;

      if (!animationListener && mounted) {
        var transitionEvent = (0, _gerenciatdUtils.whichAnimationEvent)();
        var element = document.getElementById('animationReferenceFO');

        if (transitionEvent) {
          element.addEventListener(transitionEvent, function () {
            _this.unMount();
          });

          _this.setState({
            animationListener: true
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setMyVisibility", function () {
      var _this$props = _this.props,
          idFlyOutVisible = _this$props.idFlyOutVisible,
          idFlyOut = _this$props.idFlyOut;

      if (!idFlyOutVisible) {
        // If there is no any flyout visible, launch idFlyout
        _this.props.setFlyOutVisibility(idFlyOut);
      } else if (idFlyOut === idFlyOutVisible) {
        // If this flyout is visible, close it
        _this.props.setFlyOutVisibility(null);

        _this.props.onClose();

        if (isIE()) {
          _this.unMount();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "unMount", function () {
      var _this$state2 = _this.state,
          animation2 = _this$state2.animation2,
          mounted = _this$state2.mounted;

      if ((animation2 === ANIMATION_FLYOUT_OUT_2 || isIE()) && mounted) {
        _this.setState({
          mounted: false,
          animationListener: false
        });
      }
    });

    var _idFlyOut = props.idFlyOut,
        _idFlyOutVisible = props.idFlyOutVisible;
    _this.state = {
      idFlyOut: _idFlyOut,
      mounted: _idFlyOutVisible && _idFlyOutVisible === _idFlyOut,
      animation1: ANIMATION_FLYOUT_IN_1,
      animation2: ANIMATION_FLYOUT_IN_2,
      animationListener: null
    };
    return _this;
  }
  /* For handle animation */


  _createClass(FlyOut, [{
    key: "render",
    value: function render() {
      var mounted = this.state.mounted;
      var _this$props2 = this.props,
          children = _this$props2.children,
          title = _this$props2.title,
          subtitle = _this$props2.subtitle;

      if (mounted) {
        var _this$state3 = this.state,
            animation1 = _this$state3.animation1,
            animation2 = _this$state3.animation2,
            idFlyOut = _this$state3.idFlyOut;
        return _reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
          store: this.props.store
        }, /*#__PURE__*/_react["default"].createElement("div", {
          idflyout: idFlyOut,
          className: "flyOutContainer"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(animation1),
          onClick: this.setMyVisibility
        }), /*#__PURE__*/_react["default"].createElement("section", {
          id: "animationReferenceFO",
          className: "flyOut ".concat(animation2)
        }, /*#__PURE__*/_react["default"].createElement(_gerenciatdReact["default"], {
          className: "renderXClose",
          classIcon: _gerenciatdReact2["default"].x,
          onClick: this.setMyVisibility,
          title: "cerrar"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: "ownContent"
        }, title && /*#__PURE__*/_react["default"].createElement("div", {
          className: "flyOutTitle"
        }, title), /*#__PURE__*/_react["default"].createElement("div", {
          className: "scrollContent"
        }, subtitle && /*#__PURE__*/_react["default"].createElement("div", {
          className: "flyOutSubtitle"
        }, subtitle), /*#__PURE__*/_react["default"].createElement("div", {
          className: "flyOutContent"
        }, children)))))), flyOutRoot);
      }

      return null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var idFlyOut = props.idFlyOut,
          idFlyOutVisible = props.idFlyOutVisible;
      var newMountedValue = idFlyOutVisible && idFlyOutVisible === idFlyOut;

      if (!newMountedValue) {
        return _objectSpread({}, state, {
          animation1: ANIMATION_FLYOUT_OUT_1,
          animation2: ANIMATION_FLYOUT_OUT_2
        });
      }

      return _objectSpread({}, state, {
        animation1: ANIMATION_FLYOUT_IN_1,
        animation2: ANIMATION_FLYOUT_IN_2,
        mounted: newMountedValue
      });
    }
    /* Adding animation listener */

  }]);

  return FlyOut;
}(_react.Component);

FlyOut.propTypes = {
  children: _propTypes["default"].node,
  title: _propTypes["default"].node,
  subtitle: _propTypes["default"].node,
  onClose: _propTypes["default"].func
};
FlyOut.defaultProps = {
  children: null,
  title: null,
  subtitle: null,
  onClose: function onClose() {}
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setFlyOutVisibility: function setFlyOutVisibility(idFlyOut) {
      return dispatch(_FlyOutReducer.actions.setFlyOutVisibility(idFlyOut));
    }
  };
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    idFlyOutVisible: state.flyOut.idFlyOutVisible
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FlyOut);

exports["default"] = _default;

//# sourceMappingURL=index.js.map